import {
  Box,
  Center,
  SimpleGrid,
  Text
} from "@chakra-ui/react";
import CardScope from "./cardScope";
import SectionHeading from "./sectionHeading";
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function Scope() {
  return (
    <>
      <LineSection />

      <Box
        color='white'
        bg="black"
        pb={{ base: 20, md: 40 }}
      >
        <Center>
          <Box
            w={{ base: "xl", md: "4xl", xl: "8xl" }}
            pt={20}
          >
            <Box
              align="center"
              pb={10}
            >
              <SectionHeading
                title="Scope"
              />
            </Box>

            <Center
              mt={10}
            >

              <SimpleGrid
                columns={{ base: 1, md: 3, lg: 3, xl: 3 }}
                spacing={20}
                alignItems={"flex-end"}
              >
                <Box
                  display={{ base: "none", md: "flex" }}
                >
                  <CardScope
                    image="img/asian-kid-boy-assembling-arduino-robot-car-homework-project-home.webp"
                    w={{ base: 300, md: 320, lg: "400px" }}
                    h={{ base: 400, md: 500, lg: "440px" }}
                  />
                </Box>
                <CardScope
                  image="img/teenager-plugging-energy-signal-cable-sensor-chip-toy-car-workshop.webp"
                  w={{ base: 300, md: 320, lg: "400px" }}
                  h={{ base: 400, md: 500, lg: "510" }}
                />
                <Box
                  display={{ base: "none", md: "flex" }}
                >
                  <CardScope
                    image="img/student-learning-stem-education-robotics-creating-projectbased-studying-innovation.webp"
                    w={{ base: 300, md: 320, lg: "400px" }}
                    h={{ base: 400, md: 500, lg: "440px" }}
                  />
                </Box>
              </SimpleGrid>
            </Center>

            <Text
              pt={{ base: 10, md: 40, xl: 20 }}
              px={{ base: 4, md: 6 }}
              fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              className="barlow-regular"
            >
              <Lang text="This Social Initiative is aimed at study groups belonging to schools, academies or similar, composed of students up to 17 years old residingt in Colombia and oriented to the realization of activities related to robotics or programming." />
            </Text>
          </Box>
        </Center>
      </Box>
    </>
  );
}